/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainEntitiesDocumentsDocumentContent } from './FxIdDomainEntitiesDocumentsDocumentContent';
import {
    instanceOfFxIdDomainEntitiesDocumentsDocumentContent,
    FxIdDomainEntitiesDocumentsDocumentContentFromJSON,
    FxIdDomainEntitiesDocumentsDocumentContentFromJSONTyped,
    FxIdDomainEntitiesDocumentsDocumentContentToJSON,
} from './FxIdDomainEntitiesDocumentsDocumentContent';

/**
 * @type FxIdDomainEntitiesDocumentsGameDocumentVersionContent
 * Встроенное содержимое документа. Может быть null, если контент находится по Url.
 * @export
 */
export type FxIdDomainEntitiesDocumentsGameDocumentVersionContent = FxIdDomainEntitiesDocumentsDocumentContent;

export function FxIdDomainEntitiesDocumentsGameDocumentVersionContentFromJSON(json: any): FxIdDomainEntitiesDocumentsGameDocumentVersionContent {
    return FxIdDomainEntitiesDocumentsGameDocumentVersionContentFromJSONTyped(json, false);
}

export function FxIdDomainEntitiesDocumentsGameDocumentVersionContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainEntitiesDocumentsGameDocumentVersionContent {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainEntitiesDocumentsDocumentContent(json)) {
        return FxIdDomainEntitiesDocumentsDocumentContentFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainEntitiesDocumentsGameDocumentVersionContentToJSON(json: any): any {
    return FxIdDomainEntitiesDocumentsGameDocumentVersionContentToJSONTyped(json, false);
}

export function FxIdDomainEntitiesDocumentsGameDocumentVersionContentToJSONTyped(value?: FxIdDomainEntitiesDocumentsGameDocumentVersionContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainEntitiesDocumentsDocumentContent(value)) {
        return FxIdDomainEntitiesDocumentsDocumentContentToJSON(value as FxIdDomainEntitiesDocumentsDocumentContent);
    }

    return {};
}

